import { Component, ElementRef, Inject, NgZone, PLATFORM_ID, TransferState } from '@angular/core';

import { DxTemplateHost, DxToastComponent, NestedOptionHost, WatcherHelper } from 'devextreme-angular';

@Component({
  selector: 'abc-toast',
  template: '',
  standalone: true,
  providers: [DxTemplateHost, WatcherHelper, NestedOptionHost],
})
export class AbcToastComponent extends DxToastComponent {
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, optionHost, transferState, platformId);
  }
}
